import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import WebsocketClient, { WebsocketsListener } from './../utils/ws';

// Register the router hooks with their names
Component.registerHooks(['beforeRouteLeave']);

export default class ComponentWithSocket extends Vue {
    wsListener: WebsocketsListener;

    constructor() {
        super();
        this.wsListener = new WebsocketsListener();
    }

    public _beforeLeave(to: any, from: any) {
        console.log('Component unmonunted here');
        this.wsListener.destroy();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/lib/component.ts